import { Gift } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import LoyaltyCard from '../components/loyalty/LoyaltyCard';

const DEFAULT_FRANCHISE_ID = 'lILDGxMgfsifzpqg4YZu';

export default function LoyaltyPage() {
  const { t } = useTranslation();
  const { user, customClaims, firebaseUser } = useAuth();
  const navigate = useNavigate();

  // Guests cannot access loyalty page
  const isGuest = customClaims?.role === 'guest' || user?.role === 'guest' || firebaseUser?.isAnonymous;
  if (isGuest) {
    return (
      <div className="max-w-md mx-auto text-center py-12 px-4">
        <div className="text-6xl mb-4">🔒</div>
        <h2 className="text-2xl font-bold text-ink mb-2">
          {t('loyalty.guestAccess.title')}
        </h2>
        <p className="text-ink-muted mb-6">
          {t('loyalty.guestAccess.description')}
        </p>
        <button
          onClick={() => navigate('/profile')}
          className="px-6 py-3 bg-info text-white font-semibold rounded-lg hover:bg-info/90 transition"
        >
          {t('loyalty.guestAccess.createAccount')}
        </button>
      </div>
    );
  }

  const franchiseId = user?.franchiseId || customClaims?.franchiseId || DEFAULT_FRANCHISE_ID;
  const branchId = user?.branchId;

  return (
    <div className="max-w-4xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-2">
          <Gift className="w-8 h-8 text-info" />
          <h1 className="text-3xl font-bold text-ink">
            {t('loyalty.page.title')}
          </h1>
        </div>
        <p className="text-ink-muted">
          {t('loyalty.page.subtitle')}
        </p>
      </div>

      {/* Loyalty Card */}
      <LoyaltyCard franchiseId={franchiseId} branchId={branchId} />
    </div>
  );
}
